
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { BigCalendar } from "../Components/BigCalendar.js";
import { empty, singleton, toArray, ofArray, tryFind, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Event$ } from "../Bindings/Feliz.ReactBigCalendar.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Button, TextButton } from "../Components/Button.js";
import { Skeleton } from "../Components/Skeleton.js";
import { Dialog } from "../Components/Dialog.js";
import { Msg } from "./Types.js";

export function CalenderContent(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton((elems = [createElement(BigCalendar, {
        Events: map((data) => {
            let matchValue, matchValue_1;
            return new Event$(data.Id, (matchValue = data.DateType, (matchValue.tag === 1) ? concat(t("tool.planning.reminder"), ": ", ...data.Title) : ((matchValue.tag === 2) ? concat(t("tool.planning.inspection"), ": ", ...data.Title) : concat(t("tool.planning.reservation"), ": ", ...data.Title))), data.StartDate, (matchValue_1 = data.EndDate, (matchValue_1 != null) ? matchValue_1 : data.StartDate), true);
        }, props.CalendarData),
        OnSelect: (calendarInfo) => {
            const calendarData = tryFind((tool) => (tool.Id === calendarInfo.id), props.CalendarData);
            if (calendarData != null) {
                RouterModule_nav(ofArray(toArray(calendarData.OnClickRoute)), 1, 1);
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export function CalendarView() {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsSubscribeDialogOpen = patternInput_2[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const children = toList(delay(() => {
        let elems;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mb-4"])], (elems = [createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("calendar.subscribe_title"),
            OnClick: () => {
                setIsSubscribeDialogOpen(true);
            },
            TestId: "calendar-subscribe-button",
            Variant: "blueButton",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let matchValue;
            return append((matchValue = state_1.CalendarData, (matchValue.tag === 1) ? singleton_1(createElement(CalenderContent, {
                CalendarData: matchValue.fields[0],
            })) : singleton_1(createElement(Skeleton, {
                Variant: "table",
            }))), delay(() => {
                let Title;
                return singleton_1(createElement(Dialog, (Title = t("calendar.subscribe_title"), {
                    Body: toList(delay(() => append(singleton_1(reactElement("p", {
                        className: join(" ", ["text-sm", "text-text-muted", "mb-4"]),
                        children: t("calendar.subscribe_description"),
                    })), delay(() => {
                        let token, elems_1;
                        const matchValue_1 = state_1.CalendarToken;
                        return (matchValue_1.tag === 1) ? ((matchValue_1.fields[0] != null) ? ((token = matchValue_1.fields[0], append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "mb-4"])], (elems_1 = [reactElement("input", {
                            readOnly: true,
                            value: token.SubscriptionUrl,
                            className: join(" ", ["flex-1", "text-sm", "border", "border-border", "rounded-lg", "px-3", "py-2", "bg-background", "text-text-muted", "font-mono"]),
                        }), createElement(Button, {
                            ComponentState: componentState,
                            Label: t("general.copy"),
                            OnClick: () => {
                                navigator.clipboard.writeText(token.SubscriptionUrl);
                            },
                            TestId: "calendar-copy-url",
                            Variant: "secondary",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                            let elems_2;
                            return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2"])], (elems_2 = [createElement(Button, {
                                ComponentState: componentState,
                                Label: t("calendar.regenerate_token"),
                                OnClick: () => {
                                    dispatch(new Msg(8, []));
                                },
                                TestId: "calendar-regenerate-token",
                                Variant: "secondary",
                            }), createElement(Button, {
                                ComponentState: componentState,
                                Label: t("calendar.delete_token"),
                                OnClick: () => {
                                    dispatch(new Msg(11, []));
                                },
                                TestId: "calendar-delete-token",
                                Variant: "redButton",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                        })))) : singleton_1(createElement(Button, {
                            ComponentState: componentState,
                            Label: t("calendar.create_token"),
                            OnClick: () => {
                                dispatch(new Msg(5, []));
                            },
                            TestId: "calendar-create-token",
                            Variant: "primary",
                        }))) : singleton_1(createElement(Skeleton, {
                            Variant: "normal",
                        }));
                    })))),
                    Controls: empty(),
                    IsOpen: patternInput_2[0],
                    OnClose: () => {
                        setIsSubscribeDialogOpen(false);
                    },
                    Title: Title,
                })));
            }));
        }));
    }));
    return reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

